import { render, staticRenderFns } from "./WkExport.vue?vue&type=template&id=f5b39b8a&scoped=true&"
import script from "./WkExport.vue?vue&type=script&lang=js&"
export * from "./WkExport.vue?vue&type=script&lang=js&"
import style0 from "./WkExport.vue?vue&type=style&index=0&id=f5b39b8a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b39b8a",
  null
  
)

export default component.exports